<template>

<label class="changes" v-if="changeLog">
    <input type="checkbox">
    <span class="initials">{{ changeLog.user_initials }}</span>
    <div class="change-list">
        <slot v-if="$slots.default"></slot>
        <template v-else>
            <div class="log-time">{{ $moment(changeLog.log_time, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY HH:mm') }}</div>
            <div class="old-value" v-if="changeLog.field_name.indexOf('date') > -1">{{ changeLog.old_value ? $moment(changeLog.old_value, 'YYYY-MM-DD').format('MM/DD/YYYY') : 'BLANK' }}</div>
            <div class="old-value" v-else>{{ changeLog.old_value || 'BLANK' }}</div>
        </template>
    </div>
</label>

</template>

<script>
export default {
    name: 'changes',
    props: [ 'changeLog' ]
}
</script>

<style lang="scss">
label.changes {
    position: absolute !important;
    right: 2px;
    top: 5px;
    background: white;
    z-index: 99;

    .change-list {
        z-index: 100;
        background: white;
        padding: 5px;
        // box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.75);
        border-radius: 3px;
        border: 1px solid #bfbfbf;
        cursor: pointer;
    }
    .log-time {
        border-width: 0 !important;
        margin: 0 10px 10px 0;
    }
    .old-value {
        border-width: 0 !important;
        .checkbox {
            border-width: 0 !important;
        }
    }
    span.initials { color: blue; cursor: pointer; padding: 2px; background: #CCC; border-radius: 5px; }
    input[type="checkbox"] { display: none; }
    input[type="checkbox"] ~ .change-list { display: none; }
    input[type="checkbox"]:checked ~ .change-list { display: inline-block; }
    input[type="checkbox"]:checked ~ .initials { display: none; }
}
.table .change-list {
    width: 300px;
}
</style>
